import { X, Sparkles } from "lucide-react";
import { CHANGELOG, formatRoDate } from "@/lib/changelog";

// Fereastra „Ce e nou" — listează changelog-ul (cele mai noi versiuni sus).
export default function WhatsNewModal({ open, onClose }) {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="whats-new-modal"
            style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 z-10 flex flex-col max-h-[85vh]">
                <div className="flex items-center justify-between px-5 py-4 border-b border-[#E4E4E7] flex-shrink-0">
                    <h2 className="font-bold text-[#111827] flex items-center gap-2" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                        <Sparkles size={18} className="text-[#002FA7]" /> Ce e nou în TOM
                    </h2>
                    <button onClick={onClose} data-testid="whats-new-close"
                        className="text-[#9CA3AF] hover:text-[#111827] p-1 rounded hover:bg-[#F1F3F5] transition-colors">
                        <X size={18} />
                    </button>
                </div>
                <div className="px-5 py-4 overflow-y-auto space-y-6">
                    {CHANGELOG.map((rel, idx) => (
                        <div key={rel.version} data-testid={`changelog-${rel.version}`}
                            className={idx > 0 ? "pt-5 border-t border-[#F3F4F6]" : ""}>
                            <div className="flex items-baseline gap-2 mb-1.5 flex-wrap">
                                <span className="text-sm font-bold text-[#002FA7]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                                    Versiunea {rel.version}
                                </span>
                                <span className="text-xs text-[#9CA3AF]">· {formatRoDate(rel.date)}</span>
                            </div>
                            {rel.title && <p className="text-sm font-semibold text-[#111827] mb-2">{rel.title}</p>}
                            <ul className="list-disc pl-5 space-y-1.5 text-sm text-[#374151] leading-relaxed">
                                {rel.changes.map((c, i) => <li key={i}>{c}</li>)}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
